'use strict';

var _ = require('lodash');
var CompetitorFaresChartTimeWindowService = function CompetitorFaresChartTimeWindowService($filter, momentService, dataRetrieverConstantsService, hepService, competitorFaresCommonService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getCompTimeWindowConfigFromHep(hepConfig) {
    return {
      beforeTime: hepConfig.hepList[0].properties.competitorTimeWindowParam.timeDifferenceInMinutesBeforeHost,
      afterTime: hepConfig.hepList[0].properties.competitorTimeWindowParam.timeDifferenceInMinutesAfterHost
    };
  }
  function getCompTimeWindowConfigDefault() {
    return hepService.getDefaultCompetitorTimeWindow().then(function (hepConfig) {
      return getCompTimeWindowConfigFromHep(hepConfig);
    });
  }
  function getCompTimeWindowConfig(origin, destination) {
    return hepService.getCompetitorTimeWindow(origin, destination).then(function (hepConfig) {
      return hepConfig.hepList && !_.isEmpty(hepConfig.hepList) ? getCompTimeWindowConfigFromHep(hepConfig) : getCompTimeWindowConfigDefault();
    });
  }
  function timeWindowAvailable(compTimeWindowConfig, screen, mode, filter, availableServices, selectedServices) {
    var isSingleService = competitorFaresCommonService.isSingleService(availableServices, selectedServices);
    var isFilterTimeWindowOnly = competitorFaresCommonService.isFilterTimeWindowOnly(filter);
    return mode === dataRetrieverConstantsService.SERVICE_MODE && isSingleService && compTimeWindowConfig || screen === dataRetrieverConstantsService.FLIGHT_SCREEN && isSingleService && isFilterTimeWindowOnly;
  }
  function getTimeString(moment) {
    return rmMomentFormat(moment, momentService.TIME_USER_SETTINGS);
  }
  function getTimeWindowLabel(compTimeWindowConfig, singleService, screen, mode, filter, availableServices, selectedServices) {
    if (timeWindowAvailable(compTimeWindowConfig, screen, mode, filter, availableServices, selectedServices)) {
      var time = singleService.departureTimeMoment;
      var startTimeMoment = time.subtract(compTimeWindowConfig.beforeTime, 'm');
      var endTimeMoment = time.add(compTimeWindowConfig.afterTime, 'm');
      return 'TIME WINDOW:  ' + getTimeString(startTimeMoment) + '-' + getTimeString(endTimeMoment);
    } else {
      return '';
    }
  }
  return {
    getCompTimeWindowConfig: getCompTimeWindowConfig,
    getTimeWindowLabel: getTimeWindowLabel
  };
};
CompetitorFaresChartTimeWindowService.$inject = ['$filter', 'MomentService', 'DataRetrieverConstantsService', 'HepService', 'CompetitorFaresCommonService'];
module.exports = CompetitorFaresChartTimeWindowService;